// extracted by mini-css-extract-plugin
export default {"clockIcon":"styles__clockIcon__f9966a31f5d823368287"};